import MovieSwipe from './movie-swipe.vue';

export default MovieSwipe;